import { RRule } from 'rrule'
import {
    toWallClockRrule,
    toWallClockExdates,
    naiveUtcToLocal,
    localToNaiveUtc,
} from '../calendar/wallClockRecurrence'

const pad = (n) => String(n).padStart(2, '0')

// "YYYY-MM-DDTHH:MM:SS" floating key for a LOCAL Date, matching toWallClockExdates.
const floatingKey = (d) =>
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
    `T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`

const expandRecurringOccurrences = (task, windowStart, windowEnd) => {
    if (!task?.Timestamp) return []

    const start = task.Timestamp.toDate()
    const end = task.TimestampEnd ? task.TimestampEnd.toDate() : start
    const duration = end - start

    if (!task.rrule) {
        if (end < windowStart || start > windowEnd) return []
        return [{ start, end }]
    }

    // Float the recurrence to wall-clock so occurrences keep their local clock
    // time across DST boundaries (see helpers/calendar/wallClockRecurrence).
    let rule
    try {
        rule = RRule.fromString(toWallClockRrule(task.rrule, start))
    } catch (e) {
        return []
    }

    const exSet = new Set(
        toWallClockExdates(Array.isArray(task.exdate) ? task.exdate : [], start)
    )

    // Look back by `duration` so an occurrence whose end is inside the window
    // (but whose start is just before windowStart) is still picked up.
    const lookBack = localToNaiveUtc(new Date(windowStart.getTime() - duration))
    const before = localToNaiveUtc(windowEnd)
    const occurrences = rule.between(lookBack, before, true)

    return occurrences
        .map(naiveUtcToLocal)
        .filter((occStart) => !exSet.has(floatingKey(occStart)))
        .map((occStart) => ({
            start: occStart,
            end: new Date(occStart.getTime() + duration),
        }))
}

export default expandRecurringOccurrences
